export var EMAIL_MAX_CHARACTERS = 255;
export var PASSWORD_MAX_CHARACTERS = 255;